import { Helmet } from 'react-helmet-async';
import DefaultLayout from '../../../layouts/DefaultLayout';

const LayoutRenderer = ({ Component, ...props }) => {
    const Layout = Component.Layout || DefaultLayout;
    const pageTitle = Component.PageTitle ? `${Component.PageTitle ?? 'Page'} :: Portail PETROSIL` : null;

    return (
        <Layout>
            {pageTitle && (
                <Helmet>
                    <title>{pageTitle}</title>
                </Helmet>
            )}

            <Component {...props} />
        </Layout>
    );
};

export default LayoutRenderer;
